// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as SmsSendMessageApiModel from "../api-model/SmsSendMessageApiModel.bs.js";

function apiModelToEntity(res) {
  return {
          status_code: res.status_code,
          status: res.status
        };
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(SmsSendMessageApiModel.t_decode(json), "SmsSendMessageEntityMapper.res"));
}

export {
  apiModelToEntity ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
